module.exports = __webpack_public_path__ + "images/imageexplore4.a9ca18ac.png";